var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heroes-side-picks-hero",class:_vm.classes},[(_vm.hero)?_c('Hero',{staticClass:"heroes-side-picks-hero__hero",attrs:{"hero":_vm.hero}}):_c('div',{staticClass:"heroes-side-picks-hero__default"},[_vm._v("?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }